'use strict';

$(document).ready(function () {
    $('.experience-commerce_assets-spacer').each(function( index ) {
        $(this).prev("div[class^='experience-commerce_layouts'], div[class*=' experience-commerce_layouts']").css('margin-bottom', '0');
    });
});
